/**
 * La grille de « Mes quêtes » : une carte par ligne sur un téléphone, deux à partir de `md` (800).
 * Les cartes restent dans l'ordre du catalogue, ligne par ligne, à toutes les largeurs.
 *
 * Une feuille partagée : la page et son squelette posent LA MÊME, pour que les cartes tombent là
 * où le squelette les annonçait.
 */
import { StyleSheet } from "react-native-unistyles"

export const questsGridStyles = StyleSheet.create((theme) => ({
    grid: {
        width: "100%",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "space-between",
        rowGap: theme.spacing["4"],
    },
    /** Deux cellules laissent entre elles l'écart d'une gouttière ; une cellule seule ne s'étire pas. */
    cell: {
        flexBasis: { xs: "100%", md: "49.2%" },
        flexGrow: 0,
        flexShrink: 1,
        minWidth: 0,
    },
}))
